const GreenBigDrop = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="419"
      height="376"
      fill="none"
      viewBox="0 0 419 376"
    >
      <path
        fill="#E6F7F6"
        d="M309.334 46.112c11.898 10.685 21.015 23.63 28.894 37.451 10.253 17.949 18.151 36.948 24.869 56.446 12.897 37.431 21.834 75.916 29.784 114.629 6.989 34.051 13.935 68.092 20.952 102.14 1.079 5.26 2.484 10.457 3.741 15.684.214.85.361 1.721.559 2.683-9.514-.134-18.808-.417-28.122-.365-28.84.182-57.69.53-86.537.781-36.208.306-72.397 0-108.481-3.252-25.376-2.302-50.525-5.999-74.98-13.369-21.21-6.396-40.98-15.56-57.652-30.562C43.916 311.79 29 292.545 18.341 270.084 4.93 241.86-1.187 212.149.197 180.942c1.35-30.607 9.763-59.23 25.09-85.713 15.963-27.547 37.52-49.84 64.677-66.544C119.578 10.46 151.85 1.18 186.599.82c28.856-.294 56.336 5.816 82.337 18.397 14.677 7.097 28.228 15.988 40.341 26.872l.057.022z"
      ></path>
      <path
        fill="url(#paint0_linear_3105_19385)"
        fillOpacity="0.2"
        d="M309.334 46.112c11.898 10.685 21.015 23.63 28.894 37.451 10.253 17.949 18.151 36.948 24.869 56.446 12.897 37.431 21.834 75.916 29.784 114.629 6.989 34.051 13.935 68.092 20.952 102.14 1.079 5.26 2.484 10.457 3.741 15.684.214.85.361 1.721.559 2.683-9.514-.134-18.808-.417-28.122-.365-28.84.182-57.69.53-86.537.781-36.208.306-72.397 0-108.481-3.252-25.376-2.302-50.525-5.999-74.98-13.369-21.21-6.396-40.98-15.56-57.652-30.562C43.916 311.79 29 292.545 18.341 270.084 4.93 241.86-1.187 212.149.197 180.942c1.35-30.607 9.763-59.23 25.09-85.713 15.963-27.547 37.52-49.84 64.677-66.544C119.578 10.46 151.85 1.18 186.599.82c28.856-.294 56.336 5.816 82.337 18.397 14.677 7.097 28.228 15.988 40.341 26.872l.057.022z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_3105_19385"
          x1="42.028"
          x2="418.065"
          y1="70.782"
          y2="375.23"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#22CDC6"></stop>
          <stop offset="1" stopColor="#22CDC6" stopOpacity="0"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
};
export default GreenBigDrop;
